export default [
    "API_URL",
    "ADMIN_URL",
    "IDP_URL",
    "SENTRY_ENV",
    "ADMIN_SENTRY_DSN",
    "BUILD_NUMBER",
    "COMMIT_SHA",
    "COMMIT_LAST_DATE",
    "BUILD_DATE",
] as const; // Add available environment variables here
